import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useMatch, useNavigate } from "react-router-dom";
import { useStyles } from "components/Layout/AppDrawer/components/DrawerItem.styles";

const DowntimeHelpLink = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const matchPath = useMatch(
        `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.DOWNTIME_MODULE_HELP}`,
    );
    return (
        <ListItemButton
            className={`${classes.drawerItem} ${matchPath ? classes.drawerItemSelected : ""}`}
            onClick={() =>
                navigate(`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.DOWNTIME_MODULE_HELP}`)
            }
        >
            <ListItemIcon>
                <InfoOutlinedIcon className={classes.drawerItemIcon} />
            </ListItemIcon>
            <ListItemText
                primary={t("corporate_backoffice.corporate_layout.app_drawer.help")}
                className={classes.drawerItemText}
            />
        </ListItemButton>
    );
};

export default DowntimeHelpLink;
